import React from 'react';
import { injectIntl } from 'react-intl';
import PageBase from '../../../widgets/PageBase/PageBase';
import CategoryTemplate from '../../../widgets/MRS/CategoryTemplate';
import ItemGroup from '../../../widgets/MRS/ItemGroup';
import { getItemFromOrder, itemSortMap } from '../../../../utils/mrs-util';

const MRSOrderPage = (props) => {
  const [errors, setErrors] = React.useState({});

  const validate = (currentItems, mrsOrder) => {
    const _errors = {};
    // For each group of items, check that each meets its dispenser requirements
    Object.entries(currentItems).forEach(([groupId, group]) => {
      const item = getItemFromOrder(group.item, mrsOrder);

      if (group.item.requiresDispenser) {
        const dispensers = group.dispensers.reduce((acc, dispenser) => {
          const d = getItemFromOrder(dispenser, mrsOrder, groupId);
          if (d) {
            return acc + d.quantity;
          } else {
            return acc;
          }
        }, 0);

        if (item && dispensers == 0) {
          _errors[groupId] = props.intl.formatMessage({
            id: 'mrs_dispenser_required_error'
          });
        } else if (item && dispensers > item.quantity) {
          _errors[groupId] = props.intl.formatMessage({
            id: 'mrs_dispenser_no_fill_item_error'
          });
        } else if (!item && dispensers > 0) {
          _errors[groupId] = props.intl.formatMessage({
            id: 'mrs_dispenser_too_many_error'
          });
        }
      }
    });

    return _errors;
  };

  const handleNext = () => {
    const _errors = validate(props.currentItems, props.mrsOrder);

    // Set in either case, if empty it clears for returning to page
    setErrors(_errors);

    if (Object.keys(_errors).length == 0) {
      props.lastCategory ? props.handleSubmit() : props.handleNextCategory();
    }
  };

  // Sort the items in the component
  const sortedItems = Object.entries(props.currentItems)
    .sort(([, a], [, b]) =>
      itemSortMap[a.item.itemCategory] - itemSortMap[b.item.itemCategory]
      || a.item.description.localeCompare(b.item.description)
    );

  return (
    <div>
      <PageBase navigation={['MRS']} includeInactiveBranches>
        <CategoryTemplate
          categoryName={props.selectedCategoryName}
          customer={props.customer}
          handleNext={handleNext}
          handleBack={() => {
            props.firstCategory ? props.cancel() : props.handleBackCategory();
          }}
          backLabel={
            props.firstCategory
              ? props.intl.formatMessage({
                  id: 'cancel'
                })
              : props.intl.formatMessage({
                  id: 'back'
                })
          }
          nextLabel={
            props.lastCategory
              ? props.intl.formatMessage({
                  id: 'review'
                })
              : props.intl.formatMessage({
                  id: 'next'
                })
          }
        >
          <div>
            {sortedItems.map(([groupId, group]) => (
              <ItemGroup
                key={groupId}
                groupId={groupId}
                group={group}
                mrsOrder={props.mrsOrder}
                customer={props.customer}
                addItem={(item) => props.addItem(group, item)}
                removeItem={props.removeItem}
                handleEditClick={props.handleEditClick}
                error={errors[groupId]}
              />
            ))}
          </div>
          {Object.keys(errors).length > 0 && (
            <div style={{ color: 'red', textAlign: 'center', marginTop: 10 }}>
              {props.intl.formatMessage({
                id: 'mrs_validation_general_error'
              })}
            </div>
          )}
        </CategoryTemplate>
      </PageBase>
    </div>
  );
};

export default injectIntl(MRSOrderPage);
